import React, { useImperativeHandle, useState } from 'react';
import { Button, Col, Modal, Row } from 'antd';
import moment from 'moment';

import { isStandingCardTime } from '@/utils/transform';
import { DATE_FORMAT } from '@/config';
import { renderIntlLabel } from '@/utils';

export interface CardInfo {
  address: string;
  agency: string;
  birthdate: string;
  effecteddate: string;
  expireddate: string;
  id: string;
  name: string;
  nation: string;
  sex: string;
  type: string;
}
interface CardInfoModalProps {
  myRef?: any;
  cardInfo?: Partial<CardInfo>;
}
export interface ImodalRef {
  openModal: () => void;
}

const CardInfoModal: React.FC<CardInfoModalProps> = ({ myRef, cardInfo }) => {
  const [visible, setVisible] = useState<boolean>(false);

  const handleOpenModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const renderCardTimeText = (val) => {
    if (isStandingCardTime(val)) return '长期';
    const itemVal = moment(val ?? null);
    if (itemVal.isValid()) {
      return itemVal.format(DATE_FORMAT);
    }
    return '';
  };

  useImperativeHandle(
    myRef,
    () => ({
      openModal: handleOpenModal,
    }),
    [],
  );

  return (
    <>
      <Modal
        title={renderIntlLabel('guest_title_detail')}
        visible={visible}
        maskClosable={false}
        footer={
          <Button type="primary" onClick={handleOk}>
            {renderIntlLabel('app_confirm_verify_btn')}
          </Button>
        }
        onCancel={handleCancel}
      >
        <Row gutter={[0, 8]}>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_name')}
          </Col>
          <Col span={18}>{cardInfo?.name}</Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_sex')}
          </Col>
          <Col span={18}>{cardInfo?.sex}</Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_nation')}
          </Col>
          <Col span={18}>{cardInfo?.nation}</Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_birth')}
          </Col>
          <Col span={18}>
            {cardInfo?.birthdate ? moment(cardInfo?.birthdate).format(DATE_FORMAT) : ''}
          </Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_address')}
          </Col>
          <Col span={18}>{cardInfo?.address}</Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_citizen_cert_no')}
          </Col>
          <Col span={18}>{cardInfo?.id}</Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_cert_identity_issuing_authority')}
          </Col>
          <Col span={18}>{cardInfo?.agency}</Col>
          <Col span={6} style={{ fontWeight: 'bold' }}>
            {renderIntlLabel('order_roomorder_cert_identity_indate')}
          </Col>
          <Col span={18}>
            {`${renderCardTimeText(cardInfo?.effecteddate)}-${renderCardTimeText(
              cardInfo?.expireddate,
            )}`}
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default React.forwardRef<ImodalRef, CardInfoModalProps>((props, ref) => (
  <CardInfoModal {...props} myRef={ref} />
));
